export const PERSONALIZED_CONTENT = {
    FUNNEL_NAME: 'lohp',
    SECTION_NAME: 'main',
};
export const PAGE_NAME = 'logged_out_homepage';
export const SUB_HEADER = 'logged_out_homepage_sub_header';
